import template from './icon-sprite.generated.html';

export const IconSpriteComponent = {
  name: 'iconSprite',
  restrict: 'E',
  template
};
